import React, { useState } from "react";
import "./index.scss";
// import noPictureAvailable from "../../assets/images/no-picture-available.jpg";
import pdfImg from "../../assets/images/pdf.png";
// import Lightbox from "react-image-lightbox";
// import "react-image-lightbox/style.css";
import { imageUrlOthers } from "../../services/CommonUrl";
// import { Link } from "react-router-dom";
// import { collectIcons } from "../../helpers";
import { getIconForDaysType } from "../icon-days-type";

const GalleryLightbox = ({ key, thumbnails, data }) => {
    const imagesArr = thumbnails;
    const isPDF = (file) => /\.pdf$/i.test(file);

    // console.log("GalleryLightbox==>", imagesArr, data)

    return (
        <>
            {imagesArr?.length === 0 ? (
                <li>
                    <div className='listitenaries-img-bx listitenaries-img-icon d-flex align-items-center justify-content-center'>
                        <img
                            src={getIconForDaysType(
                                data?.days_type,
                                data?.types[0]
                            )}
                            alt={data?.days_type || ""}
                        />
                    </div>
                </li>
            ) : (
                <li>
                    <div className='listitenaries-img-bx'>
                        <img
                            src={isPDF(imagesArr[0]) ? pdfImg : imageUrlOthers + imagesArr[0]}
                            alt={data?.days_type || "No Picture Available"}
                        />
                    </div>
                </li>
            )}
        </>
    );
};

export default GalleryLightbox;
